<span [@fadeInOut]="trigger" [class]="type + '-message'" role="alert">
  <i [class]="iconClass" aria-hidden="true"></i>
  {{ message }}
</span>
